/**
 * High level router.
 *
 * Note: It's recommended to compose related routes in internal router
 * components (e.g: `src/app/modules/Auth/pages/AuthPage`, `src/app/BasePage`).
 */

import { FC } from "react";
import { Routes, Route, BrowserRouter, Navigate } from "react-router-dom";
import { PrivateRoutes } from "./PrivateRoutes";
import { ErrorsPage } from "../modules/errors/ErrorsPage";
// import {Logout, AuthPage, useAuth} from '../modules/auth'
import { App } from "../App";
import { useAppSelector } from "../redux/hooks";
import Login from "../modules/customAuth/Login";
import { ReRenderProvider } from "../modules/customs/contexts/reRenderContext";

/**
 * Base URL of the website.
 *
 * @see https://facebook.github.io/create-react-app/docs/using-the-public-folder
 */
const { PUBLIC_URL } = process.env;

const AppRoutes: FC = () => {
  // const {currentUser} = useAuth()

  const { user } = useAppSelector((state) => state.auth);

  return (
    <BrowserRouter basename={PUBLIC_URL}>
      <ReRenderProvider>
        <Routes>
          <Route element={<App />}>
            <Route path="error/*" element={<ErrorsPage />} />
            {/*<Route path='logout' element={<Logout/>}/>*/}
            {/*TODO: put in here user after */}
            {user ? (
              <>
                <Route path="/*" element={<PrivateRoutes />} />
                <Route index element={<Navigate to="/dashboard" />} />
              </>
            ) : (
              <>
                <Route path="auth/*" element={<Login />} />
                <Route path="*" element={<Navigate to="/auth" />} />
              </>
            )}
          </Route>
        </Routes>
      </ReRenderProvider>
    </BrowserRouter>
  );
};

export { AppRoutes };
